export default {
    _targets: null,
    _buttons: null,
    _buttonClass: null,
    _targetClass: null,

    init() {
        this._buttons = document.querySelectorAll('[data-show]');
        this._targets = document.querySelectorAll('[data-show--target]');

        if (!this._buttons.length || !this._targets.length) {
            return;
        }

        for (const button of this._buttons) {
            button.addEventListener('click', () => {
                this._buttonClass = button.classList[0];
                const showText = button.getAttribute('data-show');
                if (button.hasAttribute("data-hide")) {
                    button.innerHTML = showText;
                    button.removeAttribute("data-hide");
                    for (const target of this._targets) {
                        this._targetClass = target.classList[0] + '--active';
                        if (target.getAttribute('data-show--target') != '0') {
                            target.classList.remove(this._targetClass);
                        } else {
                            target.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
                        }
                    }
                } else {
                    for (const target of this._targets) {
                        this._targetClass = target.classList[0] + '--active';
                        if ((target.classList.contains(this._targetClass))) {
                            continue;
                        }
                        else {
                            target.classList.add(this._targetClass);
                            if (target.classList.contains('loop-last')) {
                                button.innerHTML = 'Vis færre - ';
                                button.setAttribute("data-hide", true);
                            }
                        }
                    
                    }
                }
            });
        }
       
    }
}
